
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form} from "react-bootstrap";
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Bulldozer,ArrowsOutLineVertical,ArrowsOutLineHorizontal, Bridge   } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import vindrApi from "../utils/vindrapi";
import {format_power} from "../utils/functions";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import powerlineMode from "../utils/powerlineMode";
import TurfArea from '@turf/area';
import TurfBuffer from '@turf/buffer';
import TurfLength from '@turf/length';
import {formatArea, formatDistance, multiLine2Line} from "../utils/functions";
import PowerRoadsPanel from "../components/PowerRoadsPanel";
import LayerPowerline		from "../classes/LayerPowerline";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import drawTheme from "../utils/drawUtilsTheme";


class ToolPowerline {

	tabIndex			= null;
	highlightedOnList	= [];
	hiddenPowerlines	= [];
	allHidden			= false;
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	lastSelection		= null;
	
	type				= 'powerline'
	
	constructor(p) {
		this.parent = p;
		this.draw	= p.draw.draw;
		this.tc		= p;
		
	}

	init(){
		this.display();
		this.setEventHandlers();
		this.tc.map.getContainer().classList.add("cursor-bridge");
		this.stackDrawLayers();
	}
	exit(){
		//unhide all powerlines
		this.showAllPowerlines();
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		
		this.parent.map.getContainer().classList.remove("cursor-bridge");
		
	}
	stackDrawLayers = () =>{
		
		drawTheme.forEach((l)=>{
			if(this.tc.map.getLayer(l.id+".cold"))
				this.tc.map.moveLayer(l.id+".cold");
			if(this.tc.map.getLayer(l.id+".hot"))
				this.tc.map.moveLayer(l.id+".hot");
		});
		
	}
	setEventHandlers(){
		
		if(!this.parent)
			return;
		
		this.tc.map.on('click', this.handleClick);
		
		this.tc.map.on('draw.update', this.handleUpdate);
		
		this.tc.map.on('mouseenter', [LayerPowerline.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave', [LayerPowerline.layerId], this.handleMouseLeave);

		this.tc.map.on('mouseenter', [LayerPowerline.layerId], this.handleCursorChange);
		this.tc.map.on('mouseleave', [LayerPowerline.layerId], this.handleCursorChange);
		

	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('draw.update', this.handleUpdate);
		
		this.tc.map.off('mouseenter', [LayerPowerline.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave', [LayerPowerline.layerId], this.handleMouseLeave);

		this.tc.map.off('mouseenter', [LayerPowerline.layerId], this.handleCursorChange);
		this.tc.map.off('mouseleave', [LayerPowerline.layerId], this.handleCursorChange);
		
	}
	handleClick = (e) => {
		
		if(this.tc.secondaryHandler)
			return;
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerPowerline.layerId]});
		
		if(this.tc.handler.constructor.name == "ToolPowerlineAdd")
			return;
		
		
		var clickedPowerline = features && features[0] ? features[0].properties.powerlineid : 0;

		this.exit();
		this.tc.handler = new ToolPowerlineAdd(this.tc, clickedPowerline);
		this.tc.handler.init(e);
		
	}

	handleCursorChange = (e)=>{
		this.tc.map.getContainer().classList[e && e.type == 'mouseenter' ? 'add' : 'remove']("cursor-pointer");
		
	}
	handleMouseEnter = (e)=>{
		if(!e.features.length)
			return;
		
		var powerlineId = e.features[0].properties.powerlineid;
		


		var idx = this.tc.scenario.powerlines.findIndex((p)=>{
			return p.powerlineid == powerlineId || (p.properties && p.properties.tempid == powerlineId);
		});

		if(idx>-1){
			this.highlightedOnList = [powerlineId];
			///check if it's close to endpoints
			const geo = structuredClone(this.tc.scenario.powerlines[idx].geometry);
			geo.coordinates = geo.type == "MultiLineString" ? geo.coordinates[0] : geo.coordinates;
			var ends = [
				geo.coordinates[0], 
				geo.coordinates[geo.coordinates.length-1]
			]

			//this.addHandles(ends, powerlineId);
		}

		
		this.display();
	}
	
	
	handleMouseLeave = (e)=>{
		this.highlightedOnList = [];
		this.removeHandles();
		this.display();
	}
	
	
	addHandles(points, powerlineId){
		
		const handles = points.map((p, idx)=>{
			return {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": p
				},
				"properties" : {
					"powerlineid" : powerlineId,
					"position" : idx+1
				}
			}
		});
				
		this.removeHandles();
		this.tc.map.addSource(this.type+'_handles', {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: handles
			}
		});

		this.tc.map.addLayer({
			id: this.type+'_handle_circles',
			type: 'circle',
			source: this.type+'_handles',
			paint: {
				'circle-color': "#ff0000",
				'circle-radius': 10,
			}
		});
	}
	removeHandles(){
		const l = this.type+'_handle_circles';
		const b = this.type+'_handles';
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}
	
	highlightOnMap = (row)=>{
		
		this.tc.map.setFeatureState({id:100000000+this.getId(row), source:'pl_source'}, {hover:true});
		
	}
	deHighlightOnMap = (row)=>{
		
		this.tc.map.setFeatureState({id:100000000+this.getId(row), source:'pl_source'}, {hover:false});
		
	}
	handleEdit = (row) => {
		
		if(!row.powerlineid && !row?.properties?.tempid)
			return;
		
		const powerlineId = this.getId(row);
		
		setTimeout(()=>{
			this.exit();
			this.tc.handler = new ToolPowerlineAdd(this.tc, powerlineId);
			this.tc.handler.selected = this.selected;
			this.tc.handler.init();
			
		}, 50);
		
		
	}
	handleCreate = (e) => {
		//it's a new boundary polygon
		if (e.features && e.features[0].id){
			ToolPowerline.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type}
			this.handleUpdate(e, e.features[0].id);
		}
	
		
		this.exit(true);
		
		this.powerlineModeForce();
		//const pId = this.tc.scenario.powerlines[this.tc.scenario.powerlines.length-1].properties.tempid;
		
		
		//this.handleEdit({powerlineid:pId});	
		
	}
	handleForceCreate = () => {

		var feature = this.draw.get('added_powerline');
		if (feature && feature.geometry.coordinates.length > 2){
			ToolPowerline.lastSelection = {id: feature.id, type: feature.properties.type}
			ToolPowerline.forcedClose = true;
			this.handleUpdate(null, feature.id);
		}
		else if (feature && feature.geometry.coordinates.length < 3)
			this.draw.changeMode('simple_select');
	}
	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
		}
		ToolPowerline?.currentObj?.exit();
	}
	handleDeleteFromList(e, powerlineId){
		this.handleUpdate(e, powerlineId, true);
		this.resetLayer();
	}
	handleSelect = (e, row) => {
		const id = "powerlineid";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return this.getId(a) == this.getId(row)});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;
		this.selected.forEach((row) => {
			this.handleDeleteFromList(null, this.getId(row));
		});
		
		const {QN} = this.tc.draw.context;
		var count = this.selected.length;
		
		QN.current.show("Deleted "+this.selected.length+" powerlines", <Button variant="primary btn-sm" onClick={()=>{this.tc.undo(count)}} >Undo</Button>);
		
		this.selected = [];
		this.display();
	}
	
	handleDeleteFromPanel = (e)=>{
		if(this.draw.getMode() == 'powerline_mode'){
			this.draw.delete('added_powerline');
		}
		if(ToolPowerline.lastSelection){
			this.handleDeleteFromList(e, ToolPowerline.lastSelection.id);
		}
		this.exit(true);
		this.powerlineModeForce();
	}
	handleUpdate = (e, pl, del) => {
		//check for powerline update
		var npl = null;
		var self = this;
		
		var nplid = pl ? parseInt(pl.toString().replace(/^\D+/g, '')) : e.features[0].id.toString().replace(/^\D+/g, '');
		
		if(del)
			npl = {properties:{powerlineid:nplid} };

		if(del || (npl = this.draw.get(pl ?? e.features[0].id))){
			
			var s = {...this.tc.scenario};
			if(npl.properties.powerlineid || npl.properties.tempid) {
				
				var idx = s.powerlines.findIndex((p)=>{
					return p.powerlineid == nplid || (p.properties && p.properties.tempid == nplid);
				});

				if(idx>-1){
					if(del){
						delete s.powerlines[idx].geometry;	
					}
					else if(npl.geometry){
						s.powerlines[idx].geometry = npl.geometry;
					}
				}
				if(npl.properties.tempid)
					delete npl.id;
			}
			else {
				delete npl.id;
				npl.properties = {tempid : Math.floor(1000000 + Math.random() * 10000000)};
				npl.color = this.obj.color;
				npl.width = this.obj.width;
				npl.name = this.obj.name;
				if(ToolPowerline.forcedClose){
					npl.geometry.coordinates.pop();
					delete ToolPowerline.forcedClose;
				}
					
				s.powerlines.push(npl);
			}

			s.modified = 1;
			
			this.tc.setScenario(s);
			this.tc.record().add(s);
			this.resetLayer();
		}
	}
	handleSelectionChange = (e) => {	
		//var features = this.map.queryRenderedFeatures(e.point);
		if(!this.parent || !this.parent.scenario || !this.parent.scenario.scenario_id //check if is main scenario
		){
			this.parent.draw.draw.changeMode('simple_select');
		}
		//check if powerline is deselected or a diferent powerline
		
		if (ToolPowerline.lastSelection && (!e.features.length || e.features[0].id != ToolPowerline.lastSelection.id)){
			this.finishLastEdit();
		}
		//check if powerline is selected
		if (e.features.length && e.features[0].properties && ['powerline', 'road'].includes(e.features[0].properties.type) ){
			ToolPowerline.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type};
			return;
		}

	}
	
	finishLastEdit(e){
		if (ToolPowerline?.lastSelection?.id){
			this.handleUpdate(e, ToolPowerline.lastSelection.id);
			
		}
		ToolPowerline?.currentObj?.exit();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(parseInt(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(parseInt(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}

	pName(row, index){
		return row.name ? row.name : 'Powerline '+ (index+1);
		
	}
	handleUpdateName = (val, powerlineId) => {
		
		var s = {...this.tc.scenario};
		

		var idx = s.powerlines.findIndex((p)=>{
			return p.powerlineid == powerlineId || (p.properties && p.properties.tempid == powerlineId);
		});

		if(idx>-1){
			s.powerlines[idx].name = val;
		}
		//this.tc.draw.drawPowerLines(s);
		this.resetLayer();
		//issue exit command to refresh viewport (weird bug not deleting the pl linestring


		s.modified = 1;

		this.tc.setScenario(s);
		this.tc.record().add(s);
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}
	getId(item){
		return item.powerlineid ?? item?.properties?.tempid;
	}

	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(this.getId(row));
	}
	
	display(){
		if(this.parent.serviceBar.current)
			this.tabIndex =	this.parent.serviceBar.current.inject(this.render(), this.tabIndex);
	}
	
	contextMenuAdd(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.parent._addTurbineHandler(map_event); this.closeContextMenu();}}><Plus size={20} /> Add Powerline</button>
		);
	}
	contextMenuDelete(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.parent._remTurbineHandler(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove Powerline</button>
		);
	}
	
	calculate(p){
		
		p.width = isNaN(p.width) ? 0 : p.width;
			
		if(!p.geometry || !p.geometry.coordinates.length){
			p.length = 0;
			p.area = 0;
		}
		else {
			p.length = TurfLength({...p, ...{type:'Feature'}}, { units: 'meters' });
			p.area = p.width ? TurfArea(TurfBuffer({...p, ...{type:'Feature'}}, p.width/2, { units: 'meters' })) : 0;
		}
		return p
	}
	handleHideAllPowerlines = () => {
		if(!this.allHidden){
			this.hiddenPowerlines = this.parent.scenario.powerlines.map((t)=>{
				this.togglePowerline(this.getId(t), true, true);
				return this.getId(t);
			});
		}
		else{
			const copy = this.hiddenPowerlines.slice(0);
			copy.forEach((t)=>{this.togglePowerline(t, false, true);});
			
		}
	}
	showAllPowerlines = () => {

		this.parent.scenario.powerlines.forEach((t)=>{
			this.togglePowerline(this.getId(t), false, true);
			return this.getId(t);
		});
		this.hiddenPowerlines = [];
		this.allHidden = false;
		
	}
	handleTogglePowerline = (e, powerlineid, f, dontRefresh)=>{
		e.stopPropagation();
		this.togglePowerline(powerlineid, f, dontRefresh);
	}	
		
	togglePowerline = (powerlineid, f, dontRefresh) => {
		
		const force = typeof f == "boolean" ? f : 'undefined';
		const hide = document.querySelector("#pwr_"+powerlineid)?.classList.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		
		this.tc.map.setFeatureState({
			source: 'pl_source',
			id: 100000000+powerlineid
		}, {invisible:(force != 'undefined' ? force : hide)});
		this.tc.map.setFeatureState({
			source: 'pl_source',
			id: powerlineid
		}, {invisible:(force != 'undefined' ? force : hide)});
		
		
		
		if(!hide){
			const index = this.hiddenPowerlines.indexOf(powerlineid);
			if (index > -1) {
				this.hiddenPowerlines.splice(index, 1);
				this.allHidden = false;
			}
		}
		else
			this.hiddenPowerlines.push(powerlineid);
		
		if(this.hiddenPowerlines.length == this.tc.scenario.powerlines.filter((a)=>{return !!a.geometry}).length){
			this.allHidden = true;
			document.getElementById("pwr_master")?.classList.add("opacity-25");
		}
		else {
			this.allHidden = false;
			document.getElementById("pwr_master")?.classList.remove("opacity-25");
		}
		if(!dontRefresh)
			this.display();
	}
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer("powerlines");
		
	}
	update(){
		this.resetLayer();
	}
	removeFeature(id){
		var data = this.tc.map.getSource('pl_source')._options.data;
		//remove the original line
		var idx = data.features.findIndex((p)=>{return p.id == id});
		if(idx>-1)
			data.features.splice(idx, 1);
		//remove the original buffer
		var idx = data.features.findIndex((p)=>{return p.bufferid == id});
		if(idx>-1)
			data.features.splice(idx, 1);
		
		
		this.tc.map.getSource('pl_source').setData(data);
	}
	render(){
		const {getters} = this.parent.draw.context;
		
		var lines = this.parent.scenario.powerlines.filter((t) => t.geometry ? true : false).map(this.calculate);
		return (
			
			<div className={"project-powerlines "}>
				<div className="title">
					Powerlines
					{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
					<div className="content p-0">

						<DataTable key={123}
							data={lines}
							columns={
								[
									{
										name:<Eye id="pwr_master" onClick={this.handleHideAllPowerlines} className={""+(this.allHidden ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row) =>	(<Eye onClick={(e)=>{this.handleTogglePowerline(e, this.getId(row), undefined, false)}} id={"pwr_"+this.getId(row)} data-id={this.getId(row)}  className={""+(this.hiddenPowerlines.includes(this.getId(row)) || this.allHidden ? 'opacity-25' : '')} size={16} />),
										
										width:"28px !important",
										style: {
											padding: '0',
										}
									},
									{
										name:'',
										selector: row => row.name,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+this.getId(row)} checked={this.selected && this.selected.some((a)=>this.getId(a) == this.getId(row))} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"25px",
										style: {
											padding: '0px !important',
											width:'25px'
										}
									},
									{
										name:'NAME',
										selector: (row,index) => {return row.name},
										format: (row,index) => (<EditNow id={'powerline-'+this.getId(row)} value={this.pName(row,index)} onClick={(e)=>{this.handleEdit(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, this.getId(row))}} />),
										sortable:true,
										width:"100%",
									},
									{
										name:'Length',
										selector: row => row.length,
										format: (row,index) => formatDistance(row.length),
										sortable:true,
										width:"100%",
										center:true,
									},
									{
										name:'Width',
										selector: row => row.width,
										format: (row,index) => {return formatDistance(row.width)},
										sortable:true,
										width:"35px",
										center:true,
									},
									{
										name:'Affected',
										selector: row => row.area,
										format: (row,index) => {return formatArea(row.area, getters.user)},
										sortable:true,
										width:"100%",
										center:true,
									},

									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
													<Dropdown className="minimal">
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<DotsThreeVertical size={16} />
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEdit(row);   }}><PencilSimple size={16} /> Edit powerline</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleDeleteFromList(e, this.getId(row)); }} className="text-danger" ><Trash size={16} /> Remove powerline</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
											</div>
										),
										width:"20px !important",
										style: {
										}
									}
								]
							}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={this.highlightOnMap}
							onRowMouseLeave={this.deHighlightOnMap}
							onRowClicked={this.handleEdit }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no powerlines placed in this scenario.
									</Col>



								</Row>
							}
						/>


						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} Items selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
					</div>	


				</div>
			</div>	
			
		);
		
	}
}


class ToolPowerlineAdd extends ToolPowerline {

	tabIndexAdd = null;
	powerlineId = 0;
	
	constructor(p, powerlineId) {
		super(p);
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.powerlineId = powerlineId;
		this.get();
		this.area = 0;
		this.length = 0;
		
		return this;
	}
	
	get(){
		const idx = this.scenario.powerlines.findIndex((p)=>{
			return p.powerlineid == this.powerlineId || (p.properties && p.properties.tempid && p.properties.tempid == this.powerlineId);
		});
		
		if(idx > -1){
			this.objIdx = idx;
			this.obj = this.scenario.powerlines[idx];
			
			if(!this.obj.width)
				this.obj.width = LayerPowerline.defaultWidth;
			if(!this.obj.color)
				this.obj.color = LayerPowerline.defaultColor;
			if(!this.obj.name)
				this.obj.name = 'Powerline '+(this.scenario.powerlines.length+1)
			
		}
		else{
			this.obj = {
				name: 'Powerline '+(this.scenario.powerlines.length+1),
				width: LayerPowerline.defaultWidth,
				color: LayerPowerline.defaultColor
			}
		}
		
	}
	loadPowerLine(powerlineId){
		//find clicked powerline 
		if(!this.powerlineId)
			return;
		
		var pl =JSON.parse(JSON.stringify(this.obj));

		pl.id = 'powerline_'+this.powerlineId;
		pl.type = 'Feature';
		pl.properties = {...pl.properties, ...{
			type:'powerline', 
			powerlineid: this.powerlineId
		}};
		if(!pl.properties.width)
			pl.properties.width = this.obj.width ? this.obj.width :   this.defaultWidth;
		if(!pl.properties.color)
			pl.properties.color = this.obj.color ? this.obj.color :  this.defaultColor;
		
		
		multiLine2Line(pl);
		

		this.draw.add(pl);
		
		ToolPowerline.lastSelection = {id: pl.id, type: this.type};
		this.draw.changeMode('simple_select', { featureIds: [pl.id] });
		this.draw.changeMode('direct_select', {
			featureId: pl.id,
			coordPath: "0",
			startPos: pl.geometry.coordinates[0]
		});
		
		this.removeFeature(this.powerlineId);
		//super.removeHandles();
		
		this.stackDrawLayers();
		this.calculate();
	}
	
	init(e){
		
		var handles = []; //e ? this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerPowerline.handlesId]}) : [];
		
		if(this.tc.serviceBar.current)
			this.tabIndexAdd = this.tc.serviceBar.current.inject(this.render());
		
		this.tc.map.getContainer().classList.add("cursor-bridge");
		this.draw.changeMode('simple_select', { featureIds: [] });
		this.addBufferLayer();
		if(this.powerlineId && !handles.length){
			this.loadPowerLine();
		}
		else{
			
			this.draw.changeMode('powerline_mode', {
				powerlines: this.tc.scenario.powerlines,
				toolPowerline: this,
				startCoordinate: [e.lngLat.lng, e.lngLat.lat],
				handles: handles
			});
			if(handles.length)
				this.removeFeature(handles[0].properties.powerlineid);
		}
		this.setEventHandlers();
		this.openDrawPanel();
		this.display();
		
	}
	exit(soft){
		
		var forced = false;

		if(this.draw.getMode() == 'powerline_mode' && !soft){
			this.handleForceCreate();
			forced = true;
		}		
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndexAdd);
		this.removeEventHandlers();
		this.tc.map.getContainer().classList.remove("cursor-bridge");
		this.closeDrawPanel();
		this.removeBufferLayer();
		this.removeDrawLayer();
		//this.tc.draw.drawPowerLines(this.scenario, this.tc);
		this.resetLayer();
		this.tabIndexAdd = null;
		this.objIdx = null;
		ToolPowerline.lastSelection = null;

	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		this.tc.map.on('draw.create', this.handleCreate);
		this.tc.map.on('draw.delete', this.handleDelete);
		this.tc.map.on('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.on('draw.update', this.handleUpdate);
		this.tc.map.on('draw.modechange', this.handleModeChange);
		this.tc.map.on('draw.updatevertex', this.handleUpdateVertex);
		
		this.tc.map.on('mousemove',		this.calculate);

		this.tc.map.on('mouseenter',	[LayerPowerline.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerPowerline.layerId], this.handleMouseLeave);
		
		
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		this.removed = 0;
		
		this.tc.map.off('draw.create', this.handleCreate);
		this.tc.map.off('draw.delete',	this.handleDelete);
		this.tc.map.off('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.off('draw.update', this.handleUpdate);
		this.tc.map.off('draw.modechange', this.handleModeChange);
		this.tc.map.off('draw.updatevertex', this.handleUpdateVertex);
		
		this.tc.map.off('mousemove',	this.calculate);
		
		this.tc.map.off('mouseenter',	[LayerPowerline.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerPowerline.layerId], this.handleMouseLeave);
		super.removeEventHandlers();
		
	}
	powerlineModeForce = () => {
		
		this.tc.handler = new ToolPowerline(this.tc);
		this.tc.handler.selected = this.selected;
		this.tc.handler.init();
		
	}
	handleClick = ()=>{
		
	}
	handleUpdateVertex = (e) =>{
		
		var s = {...this.tc.scenario};
		const powerlineId = parseInt(e.featureId.toString().replace(/^\D+/g, ''));

		
		var data = this.tc.map.getSource(LayerPowerline.sourceId)._options.data;
		
		
		e.oldCoords.forEach((oldCoord) => {

			data.features.forEach((p, pIdx)=>{
				if(p.powerlineid == powerlineId || !p.geometry)
					return;

				const points = p.geometry.type == "MultiLineString" ? p.geometry.coordinates[0] : p.geometry.coordinates;
				var found = false;
				points.forEach((coord, idx)=>{
					if(coord[0] == oldCoord[0] && coord[1] == oldCoord[1]){
						points[idx] = e.newCoords;
						found = true;
					}
				});
				if(found){
					//replace buffer
					var buff = TurfBuffer(p, p.properties.width/2, { units: 'meters' });
					buff.bufferid = p.id;
					buff.id = 100000000+p.id;
					buff.properties.powerlineid = p.id;
					
					var bIdx = data.features.findIndex((b)=>{return b.bufferid == p.id});
					if(bIdx>-1){
						data.features[bIdx] = buff;
					}
					
					var pl = this.tc.scenario.powerlines.find((pl)=>{return pl.powerlineid == p.powerlineid});
					pl.geometry = p.geometry;
				}
				

			});
			
		});
		this.tc.map.getSource(LayerPowerline.sourceId).setData(data);
		
		//this.tc.draw.drawPowerLines(s);
	}
	closeDrawPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".powerlineModePanel")){
			a.remove();
		}
		
		
	}
	addBufferLayer(){
		this.removeBufferLayer();
		this.tc.map.addSource(this.type+'_buffer', {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: []
			}
		});

		this.tc.map.addLayer({
			id: this.type+'_buffer-fill',
			type: 'fill',
			source: this.type+'_buffer',
			paint: {
				'fill-color': this.obj.color,
				'fill-opacity': 0.3
			}
		});
	}
	removeBufferLayer(){
		const l = this.type+'_buffer-fill';
		const b = this.type+'_buffer';
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}
	removeDrawLayer(){
		if(ToolPowerline.lastSelection && this.draw.get(ToolPowerline.lastSelection.id)){
			let id = ToolPowerline.lastSelection.id;
			
			setTimeout(()=>{
				
				this.draw.delete(id);
			}, 10);
		}
	}
	handleModeChange = (e)=>{
		
	}
	handleSelectionChange = (e)=>{
		if(!e.features.length){
			//remove all editable drawings and switch to view mode

			this.exit();
			this.powerlineModeForce();
			//this.tc.draw.drawPowerLines(this.scenario, this.tc);
			//issue exit command to refresh viewport (weird bug not deleting the pl linestring
			
		}
	}
	
	handleOnClose = (e)=>{
		this.exit();
		this.powerlineModeForce();
	}
	handleUpdate(e, pl, del){
		
		super.handleUpdate(e, pl, del);
		this.removeBufferLayer();
		
	}
	handleColorChange = (hex)=>{
		this.obj.color = hex;
		this.addBufferLayer();
		this.calculate();
		this.updateCurrentColor(hex);
	}
	handleNameChange = (name)=>{
		this.obj.name = name;
		this.calculate();
	}
	
	handleWidthChange = (width)=>{
		this.obj.width = width;
		this.calculate();
	}

	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
			this.removeBufferLayer();
		}
		this.exit();
		this.powerlineModeForce();
	}
	openDrawPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "powerlineModePanel";
		
		this.closeDrawPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		

		ReactDOM.createRoot(wrp).render(<PowerRoadsPanel setup={{open:true, obj:this.obj, type:'Powerline'}} handler={this} onClose={this.handleOnClose} onDelete={this.handleDeleteFromPanel} onNameChange={this.handleNameChange} onColorChange={this.handleColorChange} onWidthChange={this.handleWidthChange} />	);
		
	}
	updateCurrentColor(color){
		var line;
		var mode = this.draw.getMode();
		
		var fs = this.draw.getAll();
		fs.features.forEach((f)=>{
			if(f.id == (ToolPowerline.lastSelection ? ToolPowerline.lastSelection.id : 'added_powerline')){
				f.properties.color = color;
			}
		})
		this.draw.set(fs);
		
	}
	calculate = () => {
		
		var line = false;
		
		if(this.draw.getMode() == 'powerline_mode')
			line = this.draw.get('added_powerline');
		else{
			line = this.draw.get(this.draw.getSelectedIds());
		}
	
		if(
			!line || 
			!line.geometry ||
			line.geometry?.coordinates?.length < 2
		)
			return;
		
		const buffer = TurfBuffer(line, this.obj.width/2, { units: 'meters' });

		this.tc.map.getSource(this.type+'_buffer').setData({
			type: 'FeatureCollection',
			features: [buffer]
		});
		
		// Calculate length and area
		this.length = TurfLength(line, { units: 'meters' });
		this.area = buffer ? TurfArea(buffer) : 0;
		this.display();
	}
	
	display(){
		if(this.tc.serviceBar.current)
			this.tabIndexAdd =	this.tc.serviceBar.current.inject(this.render(), this.tabIndexAdd);
	}
	render(){
		
		const {getters} = this.tc.draw.context;
		
		return (
			
			<div className={"project-powerlines "}>
				<div className="title">
					{this.obj.name}
					<span onClick={this.handleOnClose} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>
				</div>
				<div className="owner-body">

					<div className="separator">
						<span>About this powerline</span>
					</div>
					<div className="aep">
					
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Bridge size={16} />
								<span>Name: </span>
								
								{this.obj.name}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<ArrowsOutLineVertical size={16} />
								<span>Length: </span>
								
								{this.length.toFixed(0)} m
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<ArrowsOutLineHorizontal size={16} />
								<span>Width: </span>
								
								{this.obj.width} m
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Bulldozer size={16} />
								<span>Affected area: </span>
								
								{formatArea(this.area, getters.user)}
							</Col>
						</Row>
					</div>

				</div>

			</div>	
			
		);
		
	}
}
class ToolPowerlineDel extends ToolPowerline {

	
	constructor(p, powerlineId) {
		super(p);
		this.tc = this.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		
		return this;
	}
	

	
	init(){
		this.tc.map.getContainer().classList.add("cursor-trash");
		this.setEventHandlers();
		this.display();
	}
	exit(){
		this.removeEventHandlers();
		this.tc.map.getContainer().classList.remove("cursor-trash");
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		//this.tc.map.on('mousemove', this.calculate);
		//super.setEventHandlers();
		this.tc.map.on('click', ['pl_layer_buff'], this.handleDel);
		this.tc.map.off('click', ['pl_layer_buff'], this.handleClick);
		//this.tc.map.off('draw.selectionchange', super.handleSelectionChange);
		
	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		
		this.tc.map.on('click', ['pl_layer_buff'], this.handleClick);
		this.tc.map.off('click', ['pl_layer_buff'], this.handleDel);
		
		//this.tc.map.on('draw.selectionchange', this.handleSelectionChange);
		super.removeEventHandlers();
		//this.tc.map.off('mousemove', this.calculate);
	}
	handleDel = (e)=>{
		
		var clickedPowerline = e.features && e.features[0] ? e.features[0].properties.powerlineid : 0;
		
		this.handleUpdate(e, clickedPowerline, true);
		
	}
	handleOnClose = (e)=>{
		this.exit();
		
	}
	
}

export { ToolPowerline, ToolPowerlineAdd, ToolPowerlineDel};